"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable import/prefer-default-export */

// TODO: i18n
var getSelectAriaLabel = exports.getSelectAriaLabel = function getSelectAriaLabel(type, title, ariaText, isReadOnly) {
  var ariaHelper = ariaText || "Toggle list of options";
  var ariaComposite = title ? title + ", " + ariaHelper : ariaHelper;
  return "" + (isReadOnly ? "Read only " : "") + type + "-select option: " + ariaComposite;
};